import { type OpenApiSchemaCategory } from '../../api/schema';

const SUFFIX_CATEGORY = 'catalog';

export const getUrlToCategory = (companyHome: string, categorySlug: OpenApiSchemaCategory['slug']) =>
    [companyHome, SUFFIX_CATEGORY, categorySlug].join('/');
